import React from 'react'
import { Link } from 'react-router-dom';
import { Element } from 'react-scroll';
import Slider from 'react-slick';

const logos = [
  {
    image: "Beam_Group_v2.png",
    link: "https://beamgroup.ca/",
    alt: "Beam Group"
  },
  {
    image: "pathoscan_v2.png",
    link: "https://pathoscan.com/",
    alt: "PathoScan Technologies Inc."
  },
  {
    image: "HeardThat_ai_v2.png",
    link: "https://heardthat.ai/",
    alt: "Singular Hearing"
  },
  {
    image: "rolling-insights_v2.png",
    link: "https://rolling-insights.com/",
    alt: "Rolling Wave Consulting Inc."
  },
  {
    image: "neuraura_v2.png",
    link: "https://www.getlooop.com/",
    alt: "Neuraura"
  },
  { 
    image: "Dominarlo_v2.png",
    link: "http://www.dominarlo.ca/",
    alt: "Dominarlo"
  },
  {
    image: "chmltech_v2.png",
    link: "https://www.chmltech-consulting.com/",
    alt: "Chmltech Ltd."
  },
  {
    image: "pcis_v2.png",
    link: "https://pcis.com/",
    alt: "PCIS Ltd."
  },
  {
    image: "buyer_folio_v2.png",
    link: "https://buyerfolio.ai/",
    alt: "Buyer Folio Inc"
  },
  {
    image: "bayes_studio_v2.png",
    link: "https://bayesstudio.com/",
    alt: "Bayes Studio"
  },
  {
    image: "ovet_v2.png",
    link: "https://ovet.app/",
    alt: "Ovet Inc"
  },
  {
    image: "skyline_innovation_v2.png",
    link: "https://www.skylineinnovation.ca/",
    alt: "Skyline Innovation"
  },
  {
    image: "living_in_silico_v2.png",
    link: "https://livinginsilico.ca/",
    alt: "Living in Silico"
  },
  {
    image: "doorface_v2.png",
    link: "https://www.thedoorface.com/",
    alt: "Door Face Panels"
  },
  // {
  //   image: "Telus.jpeg",
  //   link: "https://culinarycompass.app/",
  //   alt: "Culinary Compass"
  // },
  {
    image: "herb_immortal_v2.png",
    link: "https://herbimmortal.ca/",
    alt: "Herb Immortal Inc"
  },
  // {
  //   image: "edgy_telecom_v2.png",
  //   link: "https://www.edgytv.ca/",
  //   alt: "Edgy Telecom"
  // },
  {
    image: "ThisFishOrange_v2.png",
    link: "https://this.fish/",
    alt: "This Fish"
  },
  {
    image: "mcmaster_continuing_education_v2.png",
    link: "https://continuing.mcmaster.ca/",
    alt: "Mcmaster Continuing Education"
  },
  {
    image: "eco_canada_v2.png",
    link: "https://eco.ca/",
    alt: "Eco Canada"
  },
  {
    image: "properate_v2.png",
    link: "https://properate.io/",
    alt: "Properate"
  },
];
    
const logoSliderMobile = {
  dots: false,
  infinite: true,
  arrows: false,
  speed: 2500,
  slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 300,
};

const logoSlider = {
  dots: false,
  infinite: true,
  arrows: false,
  speed: 2500,
  slidesToShow: 5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 300,
};

const classes = `d-flex flex-row align-items-center`;

const WILBanner = () => {
  return (
    <>
      <Element
        name="WILBanner"
        className="wil-banner datatalent-section-gap d-flex align-items-center"
      >
        <div className="container eduvibe-animated-shape">
          <div className="row g-5 align-items-center">
            <div className="col-12 px-0 px-md-4">
              <h1 className="text-center">Industry Partner<br></br><span className="color-primary">Work Integrated Learning</span></h1>
            </div>
            <div className="col-12 px-0 px-md-4">
              <p className="wil-banner-content text-center">
                At M2M Tech, we believe that practical experience is a crucial component of learning. Our <strong>Employer-Led Work Integrated Learning (WIL)</strong> experiences and <strong>hands-on internships</strong> empower you to go beyond theory - by solving real problems with real companies.
                <br></br><br></br>
                Work alongside Data Scientists, AI engineers, and Business Leaders to gain <strong>practical, portfolio-ready experience</strong> in <strong>Data Science, Machine Learning, and AI</strong> - all while building meaningful connections that fast-track your career.
              </p>
            </div>
            <div className="col-12 mt--60 px-0 px-md-4">
              <h3 className="text-center" style={{color: "#FFD000"}}>Partnered Companies</h3>
            </div>
            <Link to="/contact-us" className="wil-banner-content text-center">
              Interested in hosting or learning the benefits of hosting a WIL with M2M?&nbsp;<img src={`${process.env.PUBLIC_URL}/images/industry-wil/maki_arrow_black.svg`} alt="right arrow" />
            </Link>
            <div className="col-12 logo-slider d-block d-md-none px-0 px-md-4">
              <Slider
                className={ classes }
                { ...logoSliderMobile }
              >
                {logos.map( ( item, id ) => (
                  <div className="single-testimonial" key={ id }>
                    <div className="inner">
                      <a href={item.link}><img width={150} src={`${process.env.PUBLIC_URL}/images/business-accelerator/logos/collaborators/${item.image}`} alt={item.alt} /></a>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
            <div className="col-12 logo-slider d-none d-md-block px-0 px-md-4">
              <Slider
                className={ classes }
                { ...logoSlider }
              >
                {logos.map( ( item, id ) => (
                  <div className="single-testimonial" key={ id }>
                    <div className="inner">
                    <a href={item.link}><img width={150} src={`${process.env.PUBLIC_URL}/images/business-accelerator/logos/collaborators/${item.image}`} alt={item.alt} /></a>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default WILBanner;